<template lang="pug">
el-dialog(v-dialogDrag, title="导入更新", append-to-body, :visible.sync="uploaderExcelDialog", width="900px", :before-close="handleClose")
  .list
    choiceUp(v-if="inChoiceUp", ref="choiceUp", @uploaderInfo="uploaderInfo")
    dataViewUp(v-if="inDataView", ref="dataViewUp", :active.sync="active", :listPageId="listPageId", :excelData="excelData", @success="handlerSuccess")
  .pages
    el-button(v-if="inDataView", type="primary", plain, size="small", @click="reChoice") 重新导入
    el-button(v-if="showPreButton", type="primary", plain, size="small", @click="$refs.dataViewUp.openPre()") 预览
    el-button(v-if="showSubmitButton", type="primary", size="small", @click="$refs.dataViewUp.submit()") 提交
    el-button(type="primary", plain, size="small", @click="handleClose") 关闭
</template>

<script>
import choiceUp from "./choiceUp.vue";
import dataViewUp from "./dataViewUp.vue";
export default {
  components: { choiceUp, dataViewUp },
  props: {},
  data() {
    return {
      // ---
      uploaderExcelDialog: false,
      active: 0, // 0上传 1匹配 2预览 3提交
      excelData: [],
      // ---
      listPageId: "",
      refresh: undefined
    };
  },
  computed: {
    inChoiceUp() {
      return this.active === 0;
    },
    inDataView() {
      return this.active !== 0;
    },
    showPreButton() {
      return this.active === 1;
    },
    showSubmitButton() {
      return this.active === 2;
    }
  },
  methods: {
    open(options = {}) {
      this.active = 0;
      this.refresh = options.refresh;
      this.listPageId = options.listPageId;
      this.uploaderExcelDialog = true;
    },
    reChoice() {
      this.active = 0;
    },
    async uploaderInfo(data) {
      if (data.dataList?.length) {
        this.active = 1;
        this.excelData = data;
      } else {
        this.$message.warning("文件无有效数据");
      }
    },
    async handlerSuccess() {
      this.refresh?.();
    },
    handleClose() {
      this.active = 0;
      this.uploaderExcelDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  padding: 10px;
}
.pages {
  height: 50px;
  margin-top: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
</style>
